import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {CelebritiesList} from '../type/celebrities';

interface CelebritiesListOptionsProps {
  sortByName?: 'asc' | 'desc';
  sortByDate?: 'asc' | 'desc';
  name?: string;
  limit?: number;
  forIndexPage?: boolean;
  celebrities?: number[];
}

export const celebritiesListOptions = ({
  sortByName,
  sortByDate,
  name,
  limit,
  forIndexPage,
  celebrities,
}: CelebritiesListOptionsProps) =>
  queryOptions({
    queryKey: ['selebrities-list', sortByName, sortByDate, name, limit, celebrities],
    queryFn: async () => {
      try {
        const response = await api.get<CelebritiesList>('/celebrities', {
          params: {
            sortByName,
            sortByDate,
            name,
            limit,
            forIndexPage,
            celebrities: celebrities?.join(','),
          },
        });

        return response.data.celebrities;
      } catch (error) {
        console.error('Failed to fetch celebrities:', error);
        // Возвращаем пустой массив в случае ошибки
        return [];
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
